import "./GSPanelsDataGridStyle.css"

import { Box, Grid, Paper } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import { createStyles, makeStyles, useTheme } from "@mui/material/styles";
import {
	setSelectedAccountant,
	setSelectedAccountantName,
	setSelectedClient,
	setSelectedClientName,
} from "../../store/actions";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { T4SlipService } from "../../services/T4SlipService";
import { useDispatch } from "react-redux";

// import { T4SlipService } from 'services/T4SlipService';
// import { setSelectedAccountant, setSelectedAccountantName, setSelectedClient, setSelectedClientName } from 'store/actions';

interface IglobalSearchPanels {
	responseData: any;
}
interface IAccountantPanelResponse {
	id: string;
	accTitle: string;
}
interface IClientPanelResponse {
	id: string;
	clientName: string;
	accountantId: string;
}

interface IEmployeePanelResponse {
	id: string;
	clientId: string;
	empName: string;
	accountantId: string;
}
interface IUserPanelResponse {
	id: string;
	name: string;
}


export const GlobalSearchPanels: React.FC<IglobalSearchPanels> = ({
	responseData,
}) => {
	const theme = useTheme();
	const dispatch = useDispatch();
	const navigate = useNavigate();


	const [accountantList, setAccountantList] = useState<any>(undefined);
	const [clientList, setClinetList] = useState<any>(undefined);
	const [employeeList, setEmployeeList] = useState<any>(undefined);
	const [userList, setUserList] = useState<any>(undefined);
	// const [vendorList, setVendorList] = useState<any>(undefined);
	// const [recipientList, setRecipientsList] = useState<any>(undefined);
	// const [beneficiaryList, setBeneficiaryList] = useState<any>(undefined);

	const [selectedAccountantState, setSelectedAccountantState] = useState<IAccountantPanelResponse | null>(null);
	const [selectedCompanyState, setSelectedCompanyState] = useState<IClientPanelResponse | null>(null);
	const [selectedUsersState, setSelectedUsersState] = useState<IUserPanelResponse | null>(null);
	const [selectedEmployeeVendorsState, setSelectedEmployeeVendorsState] = useState<IEmployeePanelResponse | null>(null);
	useEffect(() => {

		if (responseData) {
			setSelectedAccountantState(null)
			setSelectedCompanyState(null)
			setSelectedUsersState(null)
			setSelectedEmployeeVendorsState(null)
			if (responseData.accountants.length !== 0) {
				setAccountantList(responseData.accountants);
			} else {
				setAccountantList(undefined);
			}
			if (responseData.clients.length !== 0) {
				setClinetList(responseData.clients);
			} else {
				setClinetList(undefined);
			}
			if (responseData.employees.length !== 0) {
				setEmployeeList(responseData.employees);
			} else {
				setEmployeeList(undefined);
			}
			if (responseData.users.length !== 0) {
				setUserList(responseData.users);
			} else {
				setUserList(undefined);
			}
			// //resources
			// const employees:any = []
			// // const vendors:any = []
			// // const recipients:any = []
			// // const beneficiaries:any = []
			// responseData.resources.forEach((resource:any)=>{
			//     if(resource.roleName === 'Employee'){
			//         employees.push(resource)
			//     } else if (resource.roleName === 'Vendor'){
			//         vendors.push(resource);
			//     } else if (resource.roleName === 'T5_Recipient'){
			//         recipients.push(resource);
			//     } else if (resource.roleName === 'T3_Beneficiary'){
			//         beneficiaries.push(resource);
			//     }
			// })
			// setEmployeeList(employees);
			// setVendorList(vendors);
			// setRecipientsList(recipients);
			// setBeneficiaryList(beneficiaries);
		} else if (responseData === undefined) {
			setSelectedAccountantState(null)
			setSelectedCompanyState(null)
			setSelectedUsersState(null)
			setSelectedEmployeeVendorsState(null)
		}
	}, [responseData]);




	//when click on accountant id updated of accountant in redux store state.Accountant
	const onAccountantClickHandler = (tag: any, accountant?: any) => {
		const selectedAccountant = accountant ?? selectedAccountantState;
		if (selectedAccountant) {
			if (tag === 'Setup') {
				// dispatch(setSelectedAccountant({ id: selectedAccountant.id }));
				// dispatch(setSelectedAccountantName({ accTitle: selectedAccountant.accTitle }));
				navigate(`/accountants/setup/${selectedAccountant.id}`)
			} else {
				alert("Coming Soon.......")
			}
		} else {
			alert("Select AP to Load.")
		}
	};

	//when click on Client id updated of Client in redux store state.Client
	const onClientClickHandler = (tag: any, company?: any) => {
		const selectedCompany = company ?? selectedCompanyState;
		if (selectedCompany) {
			const matchingAccountant = accountantList.find(
				(acc: any) => acc.id === selectedCompany.accountantId
			);
			dispatch(setSelectedAccountant({ id: selectedCompany.accountantId }));
			dispatch(setSelectedAccountantName({ accTitle: matchingAccountant.accTitle }));
			dispatch(setSelectedClient({ id: selectedCompany.id, superUserFieldsShownInClientSetup: false }));
			dispatch(setSelectedClientName({ clientName: selectedCompany.clientName }));
			if (tag === 'Setup') {
				// alert("SUN LOO NAAAAAAAAAAAAA")
				navigate(`/clients/setup/${selectedCompany.id}`)
			} else if (tag === 'Dash') {
				navigate(`/clients/dashboard`)
				// alert("SUN LOO")
			} else {
				alert("Coming Soon.......")
			}
		} else {
			alert("Select Comapny to Load.")
		}
	};

	//when click on Employee id first change table id(Association id) to resource Actual id then navigate
	const onEmployeeClickHandler = async (tag: any, employee?: any): Promise<void> => {
		const selectedEmployee = employee ?? selectedEmployeeVendorsState;

		if (selectedEmployee) {
			// Check if the resource ID is available in the list of accountants
			const matchingAccountant = accountantList.find(
				(acc: any) => acc.id === selectedEmployee.accountantId
			);
			// Check if the resource ID is available in the list of Clients
			const matchingClient = clientList.find(
				(client: any) => client.id === selectedEmployee.clientId
			);


			dispatch(setSelectedAccountant({ id: selectedEmployee.accountantId }));
			dispatch(
				setSelectedAccountantName({ accTitle: matchingAccountant.accTitle })
			);
			dispatch(setSelectedClient({ id: selectedEmployee.clientId }));
			dispatch(setSelectedClientName({ clientName: matchingClient.clientName }));

			if (tag === 'Setup') {
				navigate(`/employee/setup/${selectedEmployee.id}`)
			} else if (tag === 'Salary') {
				navigate(`/employee/salary-profile/`)
				// navigate(`/employee/salary-profile/${selectedEmployeeVendorsState.id}`)
			} else {
				alert("Coming Soon.......")
			}

			//get employee actual id
			// try {
			// 	const response = await T4SlipService.getResourceActualId(selectedEmployeeVendorsState.id);
			// 	let path = `/resources/Employee/setup/${response.resourceId}`;
			// 	navigate(path);
			// } catch (err) {
			// }
		} else {
			alert("Select Employee / Vendors to Load.")
		}
	};

	const onUserClickHandler = async (tag: any, user?: any): Promise<void> => {
		const selectedUser = user ?? selectedUsersState;
		if (selectedUser) {
			if (tag === 'Setup') {
				// navigate(`/accountants/clients/${selectedUser.id}`)
				alert("Coming Soon.......")
			} else {
				alert("Coming Soon.......")
			}
		} else {
			alert("Select Users to Load.")
		}
		// Check if the resource ID is available in the list of accountants
		// const matchingAccountant = accountantList.find(
		// 	(acc: any) => acc.id === item.accountantId
		// );
		// // Check if the resource ID is available in the list of Clients
		// const matchingClient = clientList.find(
		// 	(client: any) => client.id === item.clientId
		// );


		// dispatch(setSelectedAccountant({ id: item.accountantId }));
		// dispatch(
		// 	setSelectedAccountantName({ accTitle: matchingAccountant.accTitle })
		// );
		// dispatch(setSelectedClient({ id: item.clientId }));
		// dispatch(setSelectedClientName({ clientName: matchingClient.clientName }));
	};

	// //when click on Vendor  first change table id(Association id) to resource Actual id then navigate
	// const onVendorClickHandler = async (item:any): Promise<void> => {

	//     // Check if the resource ID is available in the list of accountants
	//     const matchingAccountant = accountantList.find((acc:any) => acc.id === item.accountantId);
	//     // Check if the resource ID is available in the list of Clients
	//     const matchingClient = clientList.find((client:any) => client.id === item.clientId);

	//     dispatch(setSelectedAccountant({id:item.accountantId}));
	//     dispatch(setSelectedAccountantName({accTitle:matchingAccountant.accTitle}));
	//     dispatch(setSelectedClient({id:item.clientId}));
	//     dispatch(setSelectedClientName({clientName:matchingClient.clientName}));

	// //get Vendor actual id
	//     try {
	//         const response = await T4SlipService.getResourceActualId(item.id);
	//         let path = `/resources/Vendor/setup/${response.resourceId}`;
	//         navigate(path);
	//       } catch (err) {

	//       }
	//   };

	// //when click on Recipient  first change table id(Association id) to resource Actual id then navigate
	// const onRecipientClickHandler = async (item:any): Promise<void> => {
	//  
	//     // Check if the resource ID is available in the list of accountants
	//     const matchingAccountant = accountantList.find((acc:any) => acc.id === item.accountantId);
	//     // Check if the resource ID is available in the list of Clients
	//     const matchingClient = clientList.find((client:any) => client.id === item.clientId);

	//     dispatch(setSelectedAccountant({id:item.accountantId}));
	//     dispatch(setSelectedAccountantName({accTitle:matchingAccountant.accTitle}));
	//     dispatch(setSelectedClient({id:item.clientId}));
	//     dispatch(setSelectedClientName({clientName:matchingClient.clientName}));

	// //get Recipient actual id
	//     try {
	//         const response = await T4SlipService.getResourceActualId(item.id);
	//         let path = `/resources/T5_Recipient/setup/${response.resourceId}`;
	//         navigate(path);
	//       } catch (err) {
	//       
	//       }
	//   };
	// //when click on Beneficiary  first change table id(Association id) to resource Actual id then navigate
	// const onBeneficiaryClickHandler = async (item:any): Promise<void> => {

	//     // Check if the resource ID is available in the list of accountants
	//     const matchingAccountant = accountantList.find((acc:any) => acc.id === item.accountantId);
	//     // Check if the resource ID is available in the list of Clients
	//     const matchingClient = clientList.find((client:any) => client.id === item.clientId);

	//     dispatch(setSelectedAccountant({id:item.accountantId}));
	//     dispatch(setSelectedAccountantName({accTitle:matchingAccountant.accTitle}));
	//     dispatch(setSelectedClient({id:item.clientId}));
	//     dispatch(setSelectedClientName({clientName:matchingClient.clientName}));

	// //get Beneficiary actual id
	//     try {
	//         const response = await T4SlipService.getResourceActualId(item.id);
	//         let path = `/resources/T3_Beneficiary/setup/${response.resourceId}`;
	//         navigate(path);
	//       } catch (err) {
	//    
	//       }
	//   };

	return (
		<Grid
			container
			columnSpacing={3}
			size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			// sx={{ marginLeft: "-11px" }}
			sx={{ padding: "0 16px" }}
		>
			<Grid
				size={{ xs: 12, sm: 6, md: 5, lg: 4, xl: 3 }}
				sx={{ paddingTop: "2rem" }}
			>
				<Paper
					elevation={3}
					sx={{
						height: "23rem",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box
						sx={{
							fontSize: ".9rem",
							color: "#000",
							padding: "16px 16px 16px 26px",
							fontWeight: "bold",
						}}
					>
						AP
					</Box>
					<hr
						style={{
							borderColor: "rgba(0,0,0,.12)",
							border: "0",
							borderTop: "1px solid rgba(0,0,0,.1)",
							margin: 0,
						}}
					/>
					<Box
						sx={{
							padding: "10px",
							overflow: "auto",
							fontSize: "small",
							"&::-webkit-scrollbar": {
								width: "0.4em",
							},
							"&::-webkit-scrollbar-thumb": {
								background: "#a0a0a0",
								borderRadius: "3px",
							},
							"&::-webkit-scrollbar-thumb:hover": {
								backgroundColor: "#ccc",
							},
						}}
					>
						{/* {responseData && accountantList !== undefined ? (
							accountantList.map((item: any) => {
								return (
									<Box sx={{ paddingBottom: "5px" }}>
										<Link
											onClick={() => onAccountantClickHandler(item)}
											to={`/accountants/clients`}
											className="no-underline"
											style={{ color: "#0052cc" }}
										>
											{item.accTitle}
										</Link>
									</Box>
								);
							})
						) : (
							<Box sx={{ color: "red", fontSize: "small" }}>
								No record found
							</Box>
						)} */}

						<DataTable
							value={responseData && accountantList}
							responsiveLayout="scroll"
							lazy
							selection={selectedAccountantState}
							onSelectionChange={(e: any) => setSelectedAccountantState(e.value)}
							selectionMode="single"
							showGridlines
							scrollable
							emptyMessage={"No Record Found."}
							className="GSPanelsDataGrid"
							onRowDoubleClick={(e: any) => {
								onAccountantClickHandler("Dash", e.data);
							}}
						>
							<Column
								field="accTitle"
								style={{
									// color: "#0052cc", 
								}}
							></Column>
						</DataTable>

					</Box>
					<Box sx={{ bottom: 0, marginTop: "auto", fontSize: ".875rem", padding: "5px 10px", display: "flex", justifyContent: "space-around" }}>
						<span
							className="no-underline"
							style={{ color: theme.palette.primary.light, cursor: "pointer" }}
							onClick={() => onAccountantClickHandler("Setup")}
						>
							Setup
						</span>
						<span
							className="no-underline"
							style={{ color: theme.palette.primary.light, cursor: "pointer" }}
							onClick={() => onAccountantClickHandler("Dash")}
						>
							Dash
						</span>
						<span
							className="no-underline"
							style={{ color: theme.palette.primary.light, cursor: "pointer" }}
							onClick={() => onAccountantClickHandler("Doc")}
						>
							Doc
						</span>
						<span
							className="no-underline"
							style={{ color: "red", cursor: "pointer" }}
							onClick={() => onAccountantClickHandler("Delete")}
						>
							Delete
						</span>
					</Box>
				</Paper>
			</Grid>
			<Grid
				size={{ xs: 12, sm: 6, md: 5, lg: 4, xl: 3 }}
				sx={{ paddingTop: "2rem" }}
			>
				<Paper
					elevation={3}
					sx={{
						height: "23rem",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box
						sx={{
							fontSize: ".9rem",
							color: "#000",
							padding: "16px 16px 16px 26px",
							fontWeight: "bold",
						}}
					>
						Company
					</Box>
					<hr
						style={{
							borderColor: "rgba(0,0,0,.12)",
							border: "0",
							borderTop: "1px solid rgba(0,0,0,.1)",
							margin: 0,
						}}
					/>
					<Box
						sx={{
							padding: "10px",
							overflow: "auto",
							fontSize: "small",
							"&::-webkit-scrollbar": {
								width: "0.4em",
							},
							"&::-webkit-scrollbar-thumb": {
								background: "#a0a0a0",
								borderRadius: "3px",
							},
							"&::-webkit-scrollbar-thumb:hover": {
								backgroundColor: "#ccc",
							},
						}}
					>
						{/* {responseData && clientList !== undefined ? (
							clientList.map((item: any) => {
								return (
									<Box sx={{ paddingBottom: "5px" }}>
										<Link
											onClick={() => onClientClickHandler(item)}
											to={`/clients/dashboard`}
											className="no-underline"
											style={{ color: "#0052cc" }}
										>
											{item.clientName}
										</Link>
									</Box>
								);
							})
						) : (
							<Box sx={{ color: "red", fontSize: "small" }}>
								No record found
							</Box>
						)} */}
						<DataTable
							value={responseData && clientList}
							responsiveLayout="scroll"
							lazy
							selection={selectedCompanyState}
							onSelectionChange={(e: any) => setSelectedCompanyState(e.value)}
							selectionMode="single"
							showGridlines
							scrollable
							emptyMessage={"No Record Found."}
							className="GSPanelsDataGrid"
							onRowDoubleClick={(e: any) => {
								onClientClickHandler("Dash", e.data);
							}}

						>
							<Column
								field="clientName"
								style={{
									// color: "#0052cc", 
								}}
							></Column>
						</DataTable>
					</Box>
					<Box sx={{ bottom: 0, marginTop: "auto", fontSize: ".875rem", padding: "5px 10px", display: "flex", justifyContent: "space-around" }}>
						<span
							className="no-underline"
							style={{ color: theme.palette.primary.light, cursor: "pointer" }}
							onClick={() => onClientClickHandler("Setup")}
						>
							Setup
						</span>
						<span
							className="no-underline"
							style={{ color: theme.palette.primary.light, cursor: "pointer" }}
							onClick={() => onClientClickHandler("Dash")}
						>
							Dash
						</span>
						<div style={{
							display: "flex",
							flexDirection: "column",

						}}>
							<span
								className="no-underline"
								style={{ color: theme.palette.primary.light, cursor: "pointer" }}
								onClick={() => onClientClickHandler("Pad1")}
							>
								PAD 1
							</span>
							<span
								className="no-underline"
								style={{ color: theme.palette.primary.light, cursor: "pointer" }}
								onClick={() => onClientClickHandler("Pad2")}
							>
								PAD 2
							</span>
						</div>
						<div style={{
							display: "flex",
							flexDirection: "column",
						}}>
							<span
								className="no-underline"
								style={{ color: theme.palette.primary.light, cursor: "pointer" }}
								onClick={() => onClientClickHandler("Doc1")}
							>
								Doc 1
							</span>
							<span
								className="no-underline"
								style={{ color: theme.palette.primary.light, cursor: "pointer" }}
								onClick={() => onClientClickHandler("Doc2")}
							>
								Doc 2
							</span>
						</div>
						<span
							className="no-underline"
							style={{ color: "red", cursor: "pointer" }}
							onClick={() => onClientClickHandler("Delete")}
						>
							Delete
						</span>
					</Box>
				</Paper>
			</Grid>
			<Grid
				size={{ xs: 12, sm: 6, md: 5, lg: 4, xl: 3 }}
				sx={{ paddingTop: "2rem" }}
			>
				<Paper
					elevation={3}
					sx={{
						height: "23rem",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box
						sx={{
							fontSize: ".9rem",
							color: "#000",
							padding: "16px 16px 16px 26px",
							fontWeight: "bold",
						}}
					>
						Users
					</Box>
					<hr
						style={{
							borderColor: "rgba(0,0,0,.12)",
							border: "0",
							borderTop: "1px solid rgba(0,0,0,.1)",
							margin: 0,
						}}
					/>
					<Box
						sx={{
							padding: "10px",
							overflow: "auto",
							fontSize: "small",
							"&::-webkit-scrollbar": {
								width: "0.4em",
							},
							"&::-webkit-scrollbar-thumb": {
								background: "#a0a0a0",
								borderRadius: "3px",
							},
							"&::-webkit-scrollbar-thumb:hover": {
								backgroundColor: "#ccc",
							},
						}}
					>
						{/* {responseData &&
							employeeList !== undefined &&
							employeeList.length !== 0 ? (
							employeeList.map((item: any) => {
								return (
									<Box sx={{ paddingBottom: "5px" }}>
										<Link
											onClick={() => onEmployeeClickHandler(item)}
											to=""
											className="no-underline"
											style={{ color: "#0052cc" }}
										>{`${item.empName}`}</Link>
									</Box>
								);
							})
						) : (
							<Box sx={{ color: "red", fontSize: "small" }}>
								No record found
							</Box>
						)} */}
						<DataTable
							value={responseData && userList}
							responsiveLayout="scroll"
							lazy
							selection={selectedUsersState}
							onSelectionChange={(e: any) => setSelectedUsersState(e.value)}
							selectionMode="single"
							showGridlines
							scrollable
							emptyMessage={"No Record Found."}
							className="GSPanelsDataGrid"
							onRowDoubleClick={(e: any) => {
								onUserClickHandler("Setup", e.data);
							}}
						>
							<Column
								field="name"
								style={{
									// color: "#0052cc", 
								}}
							></Column>
						</DataTable>

					</Box>
					<Box sx={{ bottom: 0, marginTop: "auto", fontSize: ".875rem", padding: "5px 10px", display: "flex", justifyContent: "space-around" }}>
						<span
							className="no-underline"
							style={{ color: theme.palette.primary.light, cursor: "pointer" }}
							onClick={() => onUserClickHandler("Setup")}
						>
							Setup
						</span>

					</Box>
				</Paper>
			</Grid>
			<Grid
				size={{ xs: 12, sm: 6, md: 5, lg: 4, xl: 3 }}
				sx={{ paddingTop: "2rem" }}
			>
				<Paper
					elevation={3}
					sx={{
						height: "23rem",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box
						sx={{
							fontSize: ".9rem",
							color: "#000",
							padding: "16px 16px 16px 26px",
							fontWeight: "bold",
						}}
					>
						Employee / Vendors
					</Box>
					<hr
						style={{
							borderColor: "rgba(0,0,0,.12)",
							border: "0",
							borderTop: "1px solid rgba(0,0,0,.1)",
							margin: 0,
						}}
					/>
					<Box
						sx={{
							padding: "10px",
							overflow: "auto",
							fontSize: "small",
							"&::-webkit-scrollbar": {
								width: "0.4em",
							},
							"&::-webkit-scrollbar-thumb": {
								background: "#a0a0a0",
								borderRadius: "3px",
							},
							"&::-webkit-scrollbar-thumb:hover": {
								backgroundColor: "#ccc",
							},
						}}
					>
						{/* {responseData && userList !== undefined && userList.length !== 0 ? (
							userList.map((item: any) => {
								return (
									<Box sx={{ paddingBottom: "5px" }}>
										<Link
											onClick={() => onUserClickHandler(item)}
											to=""
											className="no-underline"
											style={{ color: "#0052cc" }}
										>{`${item.userName}`}</Link>
									</Box>
								);
							})
						) : (
							<Box sx={{ color: "red", fontSize: "small" }}>
								No record found
							</Box>
						)} */}

						<DataTable
							value={responseData && employeeList}
							responsiveLayout="scroll"
							lazy
							selection={selectedEmployeeVendorsState}
							onSelectionChange={(e: any) => setSelectedEmployeeVendorsState(e.value)}
							selectionMode="single"
							showGridlines
							scrollable
							emptyMessage={"No Record Found."}
							className="GSPanelsDataGrid"
							onRowDoubleClick={(e: any) => {
								onEmployeeClickHandler("Setup", e.data);
							}}
						>
							<Column
								field="empName"
								style={{
									// color: "#0052cc", 
								}}
							></Column>
						</DataTable>
					</Box>
					<Box sx={{ bottom: 0, marginTop: "auto", fontSize: ".875rem", padding: "5px 10px", display: "flex", justifyContent: "center", gap: "2.5rem" }}>

						<span
							className="no-underline"
							style={{ color: theme.palette.primary.light, cursor: "pointer" }}
							onClick={() => onEmployeeClickHandler("Setup")}
						>
							Setup
						</span>
						<span
							className="no-underline"
							style={{ color: theme.palette.primary.light, cursor: "pointer" }}
							onClick={() => onEmployeeClickHandler("Salary")}
						>
							Salary
						</span>

					</Box>
				</Paper>
			</Grid>
			{/* <Grid item xs={12} sm={6} md={3} lg={3} xl={3} sx={{paddingTop:"2rem"}}>
            <Paper elevation={3} className={classes.paper}>
                <Box className={classes.titleStyle}>T5 Recipients</Box>
                <hr className={classes.line}/>
                <Box className={classes.scrollBarOverFlow}>
                    {responseData && recipientList !== undefined && recipientList.length !== 0 ? recipientList.map((item:any)=>{
                        return (
                            <Box sx={{paddingBottom:"5px"}}>
                                <Link 
                                    onClick={() => onRecipientClickHandler(item)}
                                    to=''
                                    className="no-underline" 
                                    style={{color:"#0052cc"}}
                                    >{`${item.firstName} ${item.lastName}`}</Link>
                            </Box>
                        )
                    }):(
                        <Box sx={{color:"red",fontSize:"small"}}>No record found</Box>
                    )}
                </Box> 
            </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3} xl={3} sx={{paddingTop:"2rem"}}>
            <Paper elevation={3} className={classes.paper}>
                <Box className={classes.titleStyle}>T3 Beneficiary</Box>
                <hr className={classes.line}/>
                <Box className={classes.scrollBarOverFlow}>
                    {responseData && beneficiaryList !== undefined && beneficiaryList.length !== 0 ? beneficiaryList.map((item:any)=>{
                        return (
                            <Box sx={{paddingBottom:"5px"}}>
                                <Link 
                                    onClick={() => onBeneficiaryClickHandler(item)}
                                    to=''
                                    className="no-underline" 
                                    style={{color:"#0052cc"}}
                                    >{`${item.firstName} ${item.lastName}`}</Link>
                            </Box>
                        )
                    }):(
                        <Box sx={{color:"red",fontSize:"small"}}>No record found</Box>
                    )}
                </Box> 
            </Paper>
        </Grid> */}
		</Grid>
	);
};
